/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { tableOrderSchema } from "./tableOrderSchema.ts";

export const orgUnitTableRetrievePathOrgUnitIdSchema = z.uuid();

export const orgUnitTableRetrievePathTableIdSchema = z.uuid();

export const orgUnitTableRetrieveStatus200Schema = tableOrderSchema;

export const orgUnitTableRetrieveResponseSchema = orgUnitTableRetrieveStatus200Schema;
